// window.addEventListener('load', function () {
//   function showSiteLogo() {
//     gsap.fromTo('.site_text_logo', 
//       { autoAlpha: 0 }, 
//       { autoAlpha: 1, duration: 1 } // 1秒でフェードイン
//     );
//   }

//   const openingPlayedAt = localStorage.getItem("openingPlayedAt");
//   const now = Date.now();
//   const fourteenDays = 14 * 24 * 60 * 60 * 1000;

//   if (!openingPlayedAt || now - Number(openingPlayedAt) > fourteenDays) {
//     const tl = gsap.timeline();
//     tl
//       .fromTo('.ttj', { y: -100, autoAlpha: 0, delay: 1 }, { y: 0, autoAlpha: 1 })
//       .fromTo('.art', { x: 100, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
//       .to('.p-opening__logo', { duration: .5, autoAlpha: 0, scale: 1.05 }, '+=1')
//       .to('.p-opening__mask', { duration: 1.5, scaleX: 0, ease: 'power4.inOut' }, '-=.1')
//       .set('.p-opening', { autoAlpha: 0 }) // openingを隠す
//       .add(showSiteLogo); // ロゴ表示アニメーション

//     localStorage.setItem("openingPlayedAt", now.toString());
//   } else {
//     // 14日以内 → openingはすぐ消す
//     gsap.set('.p-opening', { autoAlpha: 0 });
//     showSiteLogo(); // ロゴだけアニメーション
//   }
// });

$('.js-slick-main, .js-slick-sub1, .js-slick-sub2').on('init', function(){
  $(this).css({ opacity: 0 }).animate({ opacity: 1 }, 800);
});

// slick の初期化は常に実行
$(function () {
  $(".js-slick-main").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll : 1,
    swipe: false,
    pauseOnFocus: false, 
    pauseOnHover: false,
    arrows: false,
    centerMode: true,
    lazyLoad: 'progressive',
    variableWidth: true,
    useTransform: false
  });
});

$(function () {
  $(".js-slick-sub1, .js-slick-sub2").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll : 1,
    swipe: false,
    pauseOnFocus: false, 
    pauseOnHover: false,
    arrows: false,
    rtl: true,
    centerMode: true,
    lazyLoad: 'progressive',
    variableWidth: true,
    useTransform: false
  });
});